import { PlatformSelectionTable } from '@/routes/AudiencePage/charts/PlatformSelectionTable';
import { Column, TableCell } from '@/components/Table';
import { LocationData, LocationPlaysResponse, SelectedPlatform } from '@/types/api/location';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';
import { getCountryName } from './countryUtils';

export const MapDataByPlatform = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: LocationPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  // TODO: return in API handler
  const getNthHighestValueLabel = (data: LocationData[], n: number = 1) => {
    const nthHighestValueObject = [...data].sort((a, b) => b.percentage - a.percentage)[n - 1];
    return (
      <>
        <span className="text-textDarkGrey font-normal">
          {getCountryName(nthHighestValueObject.label)}
        </span>{' '}
        <span className="text-textMedGrey font-light text-sm ml-1">
          {nthHighestValueObject.percentage.toFixed(0)}%
        </span>
      </>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', className: 'p-2' },
    { key: 'top_location_1', header: '1st', className: 'p-2' },
    { key: 'top_location_2', header: '2nd', className: 'p-2' },
    { key: 'top_location_3', header: '3rd', className: 'p-2' },
  ];

  return (
    <div className="max-w-full">
      <PlatformSelectionTable<LocationPlaysResponse, LocationPlaysResponse['plays'][number]>
        idPrefix="location-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData: LocationPlaysResponse['plays'][number]) => (
          <>
            <TableCell className="px-2">
              {rowData.country_distribution[0]
                ? getNthHighestValueLabel(rowData.country_distribution, 1)
                : null}
            </TableCell>
            <TableCell className="px-2">
              {rowData.country_distribution[1]
                ? getNthHighestValueLabel(rowData.country_distribution, 2)
                : null}
            </TableCell>
            <TableCell className="px-2">
              {rowData.country_distribution[2]
                ? getNthHighestValueLabel(rowData.country_distribution, 3)
                : null}
            </TableCell>
          </>
        )}
      />
    </div>
  );
};
